import RcObject from "./common/RcObject";
import WebLogger from "./logger/WebLogger";

export default class RcDomainClient extends RcObject {
  
  constructor(page) {
    super({});
    this._page = page;
    this._events = {};
    this._authClient = page.auth_client;
    this.deviceId = page.auth_client.deviceId;
    this.version = page.auth_client.version;
    this.apiHost = page.auth_client.apiHost;
    this.cdnHost = page.auth_client.cdnHost;
    this.debug = page.auth_client.debug;
    this.user = page.auth_client.user;
    this.log = new WebLogger(window.console, this.debug);
  }

  send(eventData) {
    if (!eventData) {
      return;
    }
    let indentSize = 0;
    this.log.info("Client Sending: {0}", [JSON.stringify(eventData, null, indentSize)])
    const socket = this._page.auth_client.socket;
    const connection = socket.connection;
    if (connection.readyState == 1) {
      this.log.info("Connected: Sending event {0}", [eventData["eventName"]]);
      connection.send(JSON.stringify(eventData));
    } else {
      this.log.info("Disconnected: Storing event {0}", [eventData["eventName"]]);
      this._events[eventData["@rid"]] = eventData;
      this._page.$connect();
    }
  }

  sendQueuedMessages() {
    const localEvents = this._events;
    this._events = {};
    const keys = Object.keys(localEvents);
    this.log.info("Sending queued messages");
    if (keys.length > 0) {
      for (let i = 0; i < keys.length; i++) {
        const eventData = localEvents[keys[i]];
        this.send(eventData);
      }
    } else {
      this.log.info("No queued messages");
    }
    this.log.info("Done queued messages");
  }

  connected() {
    const socket = this._page.auth_client.socket;
    const connection = socket.connection;
    return connection.readyState == 1;
  }

  isDebug() {
    return this.debug;
  }

  isProduction() {
    return this.debug ? false : true;
  }

  
}